import './Button.css';
import React from 'react';
import PropTypes from 'prop-types';

import { Button as AntdButton } from 'antd';

const Button = ({ type, ...props }) => {
  const Button = (
    <AntdButton
      {...props}
      className={`mbutton mbutton-${type} ${props.className || ''}`}
    />
  );
  return Button;
};

Button.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary', 'link', 'danger']),
  ...AntdButton.propTypes,
};

Button.defaultProps = {
  type: 'primary',
};

Button.displayName = 'Button';

export default Button;
